(function(){
  'use strict';
  var SESSION_KEY='edg-universal-walkthrough-v3';

  function guidedUrl(url){
    if(!url||url.indexOf('/products/')!==0) return url;
    if(url.indexOf('edg_guided=1')>=0) return url;
    var hash='',base=url,idx=base.indexOf('#');
    if(idx>=0){hash=base.slice(idx);base=base.slice(0,idx);}
    return base+(base.indexOf('?')>=0?'&':'?')+'edg_guided=1'+hash;
  }

  function blankDog(){
    return {name:'',age:'',ageUnit:'years',breed:'',fiStatus:'',fiSeries:'',wear:'',harnessChoice:'',behavior:'',product:'',measurements:{neck:'',head:''},builds:{},adapter:{family:'',placement:'',strapWidth:'',hardware:''}};
  }

  function loadStore(){
    var store=null;
    try{store=JSON.parse(sessionStorage.getItem(SESSION_KEY)||'null');}catch(e){}
    if(!store||!Array.isArray(store.dogs)||!store.dogs.length) store={dogCount:'1',dogs:[blankDog()],activeIndex:0};
    if(typeof store.activeIndex!=='number'||store.activeIndex<0||store.activeIndex>=store.dogs.length) store.activeIndex=0;
    var dog=store.dogs[store.activeIndex]||blankDog();
    dog.measurements=dog.measurements&&typeof dog.measurements==='object'?dog.measurements:{neck:'',head:''};
    dog.builds=dog.builds&&typeof dog.builds==='object'?dog.builds:{};
    dog.adapter=dog.adapter&&typeof dog.adapter==='object'?dog.adapter:{family:'',placement:'',strapWidth:'',hardware:''};
    store.dogs[store.activeIndex]=dog;
    return store;
  }

  function patchSession(state,product,adapterFamily){
    var store=loadStore(),dog=store.dogs[store.activeIndex];
    var models={fi2:'Fi 2',series3:'Series 3',series3plus:'Series 3+',mini:'Fi Mini',ultra:'Fi Ultra'};
    var series=(state.fi==='yes'||state.fi==='considering')?models[state.fiModel]||'':'';
    var status=series?'yes':state.fi==='no'?'not-currently':state.fi?'learn':'';
    var placement=state.placement||state.wear||'';
    var adapterGoal=state.goal==='adapter'||state.goal==='help';
    if(dog.fiStatus!==status||dog.fiSeries!==series||dog.wear!==(adapterGoal?placement:state.wear)){
      dog.adapter={family:'',placement:'',strapWidth:'',hardware:''};
      dog.adapterFamily='';dog.adapterPlacement='';dog.adapterWidth='';dog.adapterSnap='';
    }
    dog.fiStatus=status;dog.fiSeries=series;
    dog.wear=(adapterGoal?placement:state.wear)||'';
    dog.harnessChoice=adapterGoal&&placement==='harness'?'harness-only':'';
    dog.product=product||'';
    dog.preferredColor=state.color||'';
    dog.behavior=state.need||'';
    dog.closurePreference=state.closure||'';
    dog.backsOut=state.backsOut||'';
    dog.adapter=dog.adapter||{family:'',placement:'',strapWidth:'',hardware:''};
    if(adapterFamily)dog.adapter.family=adapterFamily;
    if(adapterGoal)dog.adapter.placement=placement==='collar'||placement==='harness'?placement:'';
    try{sessionStorage.setItem(SESSION_KEY,JSON.stringify(store));}catch(e){}
  }

  function installExactFiChoices(root){
    var panel=root.querySelector('[data-edg-panel="fi-model"]');
    if(!panel||panel.dataset.edgExactFi==='true') return;
    panel.dataset.edgExactFi='true';
    var choices=panel.querySelector('.edg-guide__choices');
    if(!choices) return;
    choices.className='edg-guide__choices edg-guide__choices--3';
    choices.innerHTML=''
      +'<button type="button" data-edg-next="fi-choice" data-edg-fi-model="fi2">Fi Series 2</button>'
      +'<button type="button" data-edg-next="fi-choice" data-edg-fi-model="series3">Fi Series 3</button>'
      +'<button type="button" data-edg-next="fi-choice" data-edg-fi-model="series3plus">Fi Series 3+</button>'
      +'<button type="button" data-edg-next="fi-choice" data-edg-fi-model="mini">Fi Mini</button>'
      +'<button type="button" data-edg-next="fi-choice" data-edg-fi-model="ultra">Fi Ultra <small>Accessories coming soon</small></button>'
      +'<button type="button" data-edg-fi-help="/pages/help-me-identify-my-fi">I’m not sure — help me identify it</button>';
  }

  function fixHomepageProductLinks(root,state){
    var integrated=state&&(state.fi==='yes'||state.fi==='considering')&&['fi2','series3','series3plus'].indexOf(state.fiModel)>=0;
    root.querySelectorAll('.edg-home__comparison-card[data-edg-collar-family]').forEach(function(card){
      var family=card.dataset.edgCollarFamily;
      var target=root.querySelector('[data-edg-result-card="'+(integrated?'fi-':'')+family+'"]');
      if(!target)return;
      var heading=card.querySelector('h3'),price=card.querySelector('.edg-client-price');
      var photo=card.querySelector('.edg-client-photo'),cta=card.querySelector('.edg-home__comparison-copy a');
      if(!card.edgStandardView)card.edgStandardView={heading:heading.textContent,price:price.textContent,photo:photo.innerHTML,cta:cta.textContent};
      var original=card.edgStandardView,title=target.querySelector('strong').textContent;
      card.querySelectorAll('a').forEach(function(link){link.href=guidedUrl(target.getAttribute('href'));});
      photo.setAttribute('aria-label',title);
      heading.textContent=integrated?title:original.heading;
      price.textContent=integrated?card.dataset.edgFiPrice:original.price;
      cta.textContent=integrated?root.dataset.edgChooseLabel.replace('[name]',title):original.cta;
      var targetImage=target.querySelector('img');
      if(integrated&&targetImage)photo.replaceChildren(targetImage.cloneNode(true));
      else photo.innerHTML=original.photo;
    });
    var specific={
      'traditional':{url:'/products/traditional-buckle-collar'},
      'martingale':{url:'/products/martingale-collar'},
      'arctic':{url:'/products/arctic-circle-collar'},
      'canvas':{url:'/products/signature-canvas-collar'},
      'fi-traditional':{url:'/products/fi-traditional-buckle-collar'},
      'fi-martingale':{url:'/products/fi-martingale-collar'},
      'fi-arctic':{url:'/products/fi-arctic-circle-collar'},
      'fi-canvas':{url:'/products/fi-signature-canvas-collar'},
      'fi3-behavior':{url:'/products/fi-3-behavior-adapter',product:'adapter',adapter:'fi3-behavior'},
      'fi3-compact':{url:'/products/fi-series-2-3-3-plus-compact-adapter',product:'adapter',adapter:'fi3-compact'},
      'mini-compact':{url:'/products/fi-mini-compact-adapter',product:'adapter',adapter:'mini-compact'}
    };
    Object.keys(specific).forEach(function(key){
      var card=root.querySelector('[data-edg-result-card="'+key+'"]');
      if(card) card.setAttribute('href',guidedUrl(specific[key].url));
    });
  }

  function installHarnessFeedback(root){
    if(root.querySelector('[data-edg-panel="harness-feedback"]')) return;
    var intro=root.querySelector('[data-edg-panel="intro"]');
    var fiContext=root.querySelector('[data-edg-panel="fi-context"]');
    if(!intro||!fiContext||!fiContext.parentNode) return;

    ['harness','both'].forEach(function(wear){
      var button=intro.querySelector('[data-edg-wear="'+wear+'"]');
      if(button) button.setAttribute('data-edg-next','harness-feedback');
    });

    var panel=document.createElement('div');
    panel.className='edg-guide__panel';
    panel.setAttribute('data-edg-panel','harness-feedback');
    panel.hidden=true;
    panel.innerHTML=''
      +'<div data-edg-harness-feedback-form-wrap>'
      +'<p class="edg-guide__step">Help shape what comes next</p>'
      +'<h2>I’m prototyping the Elite Dog Gear harness—and I’d love your input.</h2>'
      +'<p>Before I decide what the final harness should be, I want to hear what dog owners actually like, dislike, and wish existed. There are no right answers. Tell me what works for your dog and what you would build differently.</p>'
      +'<form class="edg-guide__feedback-form" action="/contact" method="post" accept-charset="UTF-8" data-edg-harness-form>'
      +'<input type="hidden" name="form_type" value="contact">'
      +'<input type="hidden" name="utf8" value="✓">'
      +'<input type="hidden" name="contact[Source]" value="EDG harness prototype research">'
      +'<div class="edg-guide__feedback-field"><label class="edg-guide__label" for="edg-harness-like">What do you like most about the harness your dog wears now?</label><textarea class="edg-guide__textarea" id="edg-harness-like" name="contact[Harness - like most]" rows="4"></textarea></div>'
      +'<div class="edg-guide__feedback-field"><label class="edg-guide__label" for="edg-harness-dislike">What do you like least about it?</label><textarea class="edg-guide__textarea" id="edg-harness-dislike" name="contact[Harness - like least]" rows="4"></textarea></div>'
      +'<div class="edg-guide__feedback-field"><label class="edg-guide__label" for="edg-harness-dream">If you could create the perfect harness for your dog, what would it be like?</label><p class="edg-guide__feedback-helper">Imagine you had full control and no limitations. Add, remove, improve, invent, or completely rethink anything you want.</p><textarea class="edg-guide__textarea edg-guide__textarea--dream" id="edg-harness-dream" name="contact[Harness - perfect harness]" rows="6"></textarea></div>'
      +'<div class="edg-guide__feedback-field"><label class="edg-guide__label" for="edg-harness-email">Your email</label><input class="edg-guide__input" id="edg-harness-email" type="email" name="contact[email]" autocomplete="email" required><p class="edg-guide__feedback-helper">Shopify requires an email to send your feedback. This does not subscribe you to marketing.</p></div>'
      +'<p class="edg-guide__feedback-status" data-edg-harness-status aria-live="polite"></p>'
      +'<div class="edg-guide__feedback-actions"><button type="submit" class="button button-solid" data-edg-harness-submit>Share my feedback &amp; continue</button><button type="button" class="button button-outline" data-edg-next="fi-context">Skip for now</button></div>'
      +'</form>'
      +'</div>'
      +'<div data-edg-harness-success hidden>'
      +'<p class="edg-guide__step">Thank you</p>'
      +'<h2>This is exactly the kind of feedback I need.</h2>'
      +'<p>I’m using what dog owners share here while I work through the EDG harness prototypes. Now let’s make sure the gear your dog uses today still works for their setup.</p>'
      +'<button type="button" class="button button-solid edg-guide__continue" data-edg-next="fi-context">Continue to my dog’s setup</button>'
      +'</div>';

    fiContext.parentNode.insertBefore(panel,fiContext);

    if(!root.querySelector('[data-edg-harness-feedback-style]')){
      var style=document.createElement('style');
      style.setAttribute('data-edg-harness-feedback-style','');
      style.textContent=''
        +'.edg-guide__feedback-form{display:grid;gap:22px;max-width:760px;margin-top:28px}'
        +'.edg-guide__feedback-field{display:grid;gap:8px}'
        +'.edg-guide__feedback-field .edg-guide__label{margin:0}'
        +'.edg-guide__textarea{width:100%;min-height:116px;border:1px solid var(--edg-line);border-radius:12px;padding:15px 16px;background:#fff;color:var(--edg-ink);font:inherit;line-height:1.55;resize:vertical}'
        +'.edg-guide__textarea--dream{min-height:170px}'
        +'.edg-guide__feedback-helper{margin:0!important;color:var(--edg-muted);font-size:.9rem;line-height:1.5}'
        +'.edg-guide__feedback-status{min-height:1.4em;margin:0!important;font-size:.92rem;line-height:1.45;color:var(--edg-muted)}'
        +'.edg-guide__feedback-actions{display:flex;flex-wrap:wrap;gap:12px;align-items:center}'
        +'.edg-guide__textarea:focus-visible{outline:3px solid rgba(83,100,88,.35);outline-offset:3px}'
        +'@media(max-width:699px){.edg-guide__feedback-actions{flex-direction:column}.edg-guide__feedback-actions .button{width:100%}}';
      root.appendChild(style);
    }
  }

  function installChoicePhotos(root){
    var source=root.querySelector('[data-edg-choice-photos]');
    if(!source)return;
    var photos=JSON.parse(source.textContent);
    root.querySelectorAll('.edg-guide__choices button').forEach(function(button){
      if(button.querySelector('img'))return;
      var d=button.dataset,key='';
      if(d.edgClosure==='buckle')key='closure_buckle';
      else if(d.edgClosure==='slip')key='closure_slip';
      else if(d.edgClosure==='unsure')return;
      else if(d.edgWear==='collar'||d.edgPlacement==='collar')key='wear_collar';
      else if(d.edgWear==='harness'||d.edgPlacement==='harness')key='harness';
      else if(d.edgWear==='both'||d.edgPlacement==='both')key='both';
      else if(d.edgWear==='unknown')key='bare_dog';
      else if(d.edgFi==='no'||d.edgInterest==='no')key='collar_clean';
      else if(d.edgFi==='considering'||d.edgInterest==='maybe')key='fi_considering';
      else if(d.edgFi||d.edgInterest)key='fi_clean';
      else if(d.edgFiModel==='series3plus'||d.edgFiModel==='fi3')key='tracker';
      else if(d.edgFiModel==='fi2')key='fi2';
      else if(d.edgFiModel==='series3')key='series3';
      else if(d.edgFiModel==='ultra')key='ultra';
      else if(d.edgFiModel==='mini')key='mini';
      else if(d.edgFiHelp!==undefined)key='dog';
      else if(d.edgGoal==='collar')key='fi_collar';
      else if(d.edgGoal==='adapter')key='adapter';
      else if(d.edgGoal==='help')key='dog';
      else if(d.edgNeed==='secure'||d.edgNeed==='escape')key='martingale';
      else if(d.edgNeed==='everyday')key='collar';
      else if(d.edgNeed==='general')key='arctic';
      else if(d.edgNeed==='visibility')key='tags';
      else if(d.edgNext==='fi-shop')key='fi_clean';
      if(!key||!photos[key])return;
      var label=document.createElement('span');label.className='edg-choice-photo-label';
      while(button.firstChild)label.appendChild(button.firstChild);
      var img=document.createElement('img');img.src=photos[key];img.alt='';img.loading='lazy';img.className='edg-choice-photo';
      if(d.edgWear==='collar'||d.edgWear==='harness'||d.edgWear==='both'||d.edgWear==='unknown'){img.style.objectFit='contain';img.style.background='#faf9f6';}
      if(key==='ultra'){img.style.objectFit='contain';img.style.background='#fff';}
      if(key==='closure_buckle'||key==='closure_slip'||key==='fi_clean'||key==='fi_considering'||key==='collar_clean'){img.style.objectFit='contain';img.style.background='#faf9f6';img.style.padding='16px';img.style.boxSizing='border-box';}
      button.appendChild(img);button.appendChild(label);button.classList.add('edg-choice-with-photo');
    });
  }
  function init(scope){
    var root=null;
    if(scope&&scope.matches&&scope.matches('[data-edg-guide-root]')) root=scope;
    if(!root&&scope&&scope.querySelector) root=scope.querySelector('[data-edg-guide-root]');
    if(!root) root=document.querySelector('[data-edg-guide-root]');
    if(!root||root.dataset.edgInitialized==='true') return;
    root.dataset.edgInitialized='true';
    var shopOpen=root.querySelector('[data-edg-shop-open]');
    var shopDialog=root.querySelector('#edg-shop-fi');
    if(shopOpen&&shopDialog){
      shopOpen.addEventListener('click',function(event){event.preventDefault();shopDialog.showModal();});
      shopDialog.addEventListener('close',function(){shopOpen.focus();});
    }
    installExactFiChoices(root);
    installHarnessFeedback(root);
    ['harness','both'].forEach(function(w){var b=root.querySelector('[data-edg-panel="intro"] [data-edg-wear="'+w+'"]');if(b)b.dataset.edgNext='fi-context';});
    fixHomepageProductLinks(root);
    installChoicePhotos(root);
    var harnessPhotos=JSON.parse(root.querySelector('[data-edg-choice-photos]').textContent);
    var harnessStrings=JSON.parse(root.querySelector('[data-edg-client-strings]').textContent);
    ['fi-context','harness-feedback','result'].forEach(function(name){
      var panel=root.querySelector('[data-edg-panel="'+name+'"]');
      if(!panel||!harnessPhotos.harness||panel.querySelector('[data-edg-harness-concept]'))return;
      var figure=document.createElement('figure');
      figure.dataset.edgHarnessConcept=name;
      figure.hidden=name!=='harness-feedback';
      figure.style.cssText='max-width:560px;margin:16px auto 24px';
      var img=document.createElement('img');img.src=harnessPhotos.harness;
      img.alt=harnessStrings.harness_alt;img.width=1536;img.height=1024;img.loading='lazy';
      img.style.cssText='display:block;width:100%;height:auto;object-fit:contain;border-radius:12px';
      var caption=document.createElement('figcaption');caption.textContent=harnessStrings.harness_caption;
      caption.style.cssText='font-size:13px;line-height:1.5;text-align:center;margin-top:8px';
      figure.appendChild(img);figure.appendChild(caption);
      var heading=panel.querySelector('h2');if(heading)heading.after(figure);else panel.prepend(figure);
    });

    var panels=[].slice.call(root.querySelectorAll('[data-edg-panel]'));
    var guide=root.querySelector('.edg-guide');
    var colorInput=root.querySelector('[data-edg-panel="color-input"] .edg-guide__input');
    var state={fi:'',interest:'',fiModel:'',goal:'',wear:'',placement:'',need:'',closure:'',backsOut:'',color:''};

    var panelHistory=[],currentPanel='intro';
    var backButton=document.createElement('button');
    backButton.type='button';backButton.className='button button-outline';
    backButton.textContent='← Back';backButton.setAttribute('data-edg-back','');
    backButton.style.cssText='min-height:44px;padding:8px 16px;margin-right:auto';
    var topline=root.querySelector('.edg-guide__topline');
    if(topline)topline.insertBefore(backButton,topline.firstChild);
    function showPanel(name,shouldScroll,goingBack,previousState){
      if(name!==currentPanel&&!goingBack)panelHistory.push({panel:currentPanel,state:Object.assign({},previousState||state)});
      currentPanel=name;
      backButton.hidden=panelHistory.length===0;

      panels.forEach(function(p){p.hidden=p.getAttribute('data-edg-panel')!==name;});
      if(name==='result') renderResult();
      if(shouldScroll!==false&&guide) guide.scrollIntoView({behavior:'smooth',block:'start'});
    }
    function showCard(name){var c=root.querySelector('[data-edg-result-card="'+name+'"]');if(c)c.hidden=false;}
    function isFi3Plus(){return state.fiModel==='series3plus';}
    function isSeries3(){return state.fiModel==='series3';}
    function isFi2(){return state.fiModel==='fi2';}

    function updateHarnessContext(){
      root.querySelectorAll('[data-edg-harness-concept]').forEach(function(figure){
        figure.hidden=figure.dataset.edgHarnessConcept==='harness-feedback'?false:!(state.wear==='harness'||state.wear==='both');
      });
      var panel=root.querySelector('[data-edg-panel="fi-context"]');
      var copy=panel&&panel.querySelector('p:not(.edg-guide__step)');
      if(copy){
        if(state.wear==='harness'){
          copy.textContent='I’m currently prototyping the Elite Dog Gear harness. Until it’s ready, keep using the harness that already works for your dog. If Fi is part of your setup, I can help match the right EDG adapter to a compatible existing harness.';
        }else if(state.wear==='both'){
          copy.textContent='I’m currently prototyping the Elite Dog Gear harness, so we’ll keep your dog’s current harness in the setup while also showing collar options. If Fi is part of the setup, I can help match the right EDG adapter to a compatible existing harness.';
        }else{
          copy.textContent='We’ll match your gear to your tracker. Fi is optional.';
        }
      }

      var fiChoice=root.querySelector('[data-edg-panel="fi-choice"]');
      var heading=fiChoice&&fiChoice.querySelector('h2');
      if(heading){
        if(state.wear==='harness') heading.textContent='Keep the current harness, or add a collar?';
        else if(state.wear==='both') heading.textContent='How would you like your dog to wear Fi?';
        else heading.textContent='How would you like your dog to wear Fi?';
      }
    }

    function renderResult(){
      var messages=JSON.parse(root.querySelector('[data-edg-client-strings]').textContent);
      var results=root.querySelector('.edg-guide__results');
      var alternatives=root.querySelector('[data-edg-alternatives]');
      var secondary=root.querySelector('[data-edg-alternative-cards]');
      root.querySelectorAll('[data-edg-result-card]').forEach(function(c){results.appendChild(c);c.classList.remove('edg-client-primary');});
      alternatives.hidden=true;alternatives.open=false;
      root.querySelectorAll('[data-edg-result-card]').forEach(function(c){c.hidden=true;});
      var title=root.querySelector('[data-edg-result-title]');
      var copy=root.querySelector('[data-edg-result-copy]');
      var colorNote=root.querySelector('[data-edg-color-note]');
      var text='';
      var fiPath=state.fi==='yes'||state.fi==='considering';
      var adapterWear=state.placement||state.wear;
      patchSession(state);
      if(fiPath){
        title.textContent=messages.fi_intro;
        if(state.interest==='yes'){
          if(isFi3Plus()) showCard('fi3-module');
          if(state.fiModel==='mini') showCard('mini-module');
        }
        if(state.goal==='adapter'||state.goal==='help'){
          if(isFi3Plus()){
            if(adapterWear==='collar'){
              showCard('fi3-behavior');showCard('fi3-compact');
              text=messages.adapter_pair;
            }else if(adapterWear==='harness'||adapterWear==='both'){
              showCard('fi3-compact');
              text=messages.adapter_harness;
            }else{
              showCard('fi3-compact');text='Confirm the mounting location before choosing a Fi 3+ adapter.';
            }
          }else if(state.fiModel==='mini'){
            showCard('mini-compact');
            text=messages.mini;
          }else if(isFi2()||isSeries3()){
            showCard('fi3-compact');
            if(state.goal==='help') showCard('fi-collars');
            text=(isFi2()?'Fi Series 2':'Fi Series 3')+' can use the EDG Compact Adapter on a compatible collar or harness for GPS and geofence placement.'+(state.goal==='help'?' Fi-integrated collar families are also available if you prefer a new collar.':'');
          }else if(state.fiModel==='ultra'){
            showCard('standard-collars');
            text=messages.ultra;
          }else{
            showCard('fi-collars');showCard('all-adapters');
            text=messages.unknown;
          }
        }else if(state.goal==='collar'){
          if(isFi3Plus()||isSeries3()||isFi2()){
            showCard('fi-collars');
            text=messages.fi_collar;
          }else if(state.fiModel==='mini'){
            showCard('standard-collars');showCard('mini-compact');
            text=messages.mini;
          }else if(state.fiModel==='ultra'){
            showCard('standard-collars');
            text=messages.ultra;
          }else{
            showCard('fi-collars');showCard('all-adapters');
            text=messages.unknown;
          }
        }else{
          showCard('fi-collars');showCard('all-adapters');
          text='The preferred Fi setup was not fully specified, so compare the verified Fi gear paths rather than forcing one product.';
        }
      }else{
        title.textContent=messages.options;
        if(state.wear==='harness'){
          title.textContent='Keep the harness that already works.';
          showCard('id-tags');
          text=messages.harness;
        }else if(state.need==='secure'||state.need==='escape'){
          showCard('martingale');showCard('standard-collars');
          text=messages.secure;
        }else if(state.wear==='collar'||state.wear==='both'){
          showCard('standard-collars');
          if(state.need==='visibility') showCard('id-tags');
          text=state.need==='visibility'?'Your dog already uses a collar and identification matters, so compare collars by fit and function and ID & Tags separately.':'You already use a collar, so start with collar options and narrow by fit, function, and the details that matter to your dog.';
        }else{
          showCard('standard-collars');showCard('id-tags');
          text='We do not have enough information to force one product type, so these are the relevant EDG categories to compare.';
        }
      }
      var preferred='';
      if(!fiPath&&(state.wear==='collar'||state.wear==='both')){
        if(state.need==='secure'||state.need==='escape') preferred='martingale';
        else if(state.need==='everyday'){preferred='traditional';text=messages.everyday;showCard(preferred);}
        else if(state.need==='general'){preferred='arctic';text=messages.general;showCard(preferred);}
      }
      if(preferred){
        var primary=root.querySelector('[data-edg-result-card="'+preferred+'"]');
        if(primary){
          primary.hidden=false;primary.classList.add('edg-client-primary');results.prepend(primary);
          root.querySelectorAll('[data-edg-result-card]').forEach(function(c){if(!c.hidden&&c!==primary)secondary.appendChild(c);});
          alternatives.hidden=!secondary.querySelector('[data-edg-result-card]:not([hidden])');
          title.textContent=messages.recommend;
        }
      }
      if(state.closure&&state.backsOut&&state.goal!=='adapter'&&state.goal!=='help'){
        var integrated=fiPath&&(isFi3Plus()||isSeries3()||isFi2());
        var prefix=integrated?'fi-':'';
        ['traditional','arctic','martingale','canvas','fi-traditional','fi-arctic','fi-martingale','fi-canvas','standard-collars','fi-collars','id-tags'].forEach(function(k){var c=root.querySelector('[data-edg-result-card="'+k+'"]');if(c){c.hidden=true;c.classList.remove('edg-client-primary');results.appendChild(c);}});
        alternatives.hidden=true;
        var choices=state.backsOut==='yes'?['martingale']:(state.closure==='buckle'?['traditional','canvas','martingale']:state.closure==='slip'?['arctic','martingale']:['traditional','canvas','arctic','martingale']);
        choices.forEach(function(k){
          var card=root.querySelector('[data-edg-result-card="'+prefix+k+'"]');if(!card)return;
          card.hidden=false;
          var detail=card.querySelector('[data-edg-closure-copy]')||card.querySelector('div > span');
          var closure=state.closure==='buckle'?'Tactical Buckle':state.closure==='slip'?'Slip-over':'Buckle or slip-over';
          if(detail&&k!=='canvas')detail.textContent=k==='traditional'?'Opens with a buckle; adjustable fit.':k==='arctic'?'Slips over the head without a buckle.':closure+' Martingale · limited-slip action when correctly fitted.';
        });
        title.textContent=state.backsOut==='yes'?'A Martingale with your preferred closure':'Compare your collar options';
        text=state.backsOut==='yes'?'A correctly fitted Martingale limits loosening when your dog backs up. '+(state.closure==='unsure'?'Choose buckle or slip-over in the build.':state.closure==='buckle'?'Choose the Tactical Buckle option in the build.':'Choose the slip-over option in the build.'):'Your closure preference and your dog’s needs guide these choices. Compare the differences below.';
        if(fiPath&&state.fiModel==='mini')text+=' Fi Mini uses a separate compatible adapter.';
        if(fiPath&&state.fiModel==='ultra')text+=' These are standard collars; an EDG Ultra mounting option is not verified.';
      }
      copy.textContent=text||'Based on what you told us, these are the most relevant places to continue.';
      if(state.color&&colorNote){colorNote.hidden=false;colorNote.textContent='Color to look for: '+state.color+'. Available colors vary by style.';}
      else if(colorNote){colorNote.hidden=true;colorNote.textContent='';}
      fixHomepageProductLinks(root,state);
    }

    root.addEventListener('click',function(event){
      if(event.target.closest('[data-edg-fi-info-open]')){var info=root.querySelector('[data-edg-fi-info]');if(info)info.showModal();return;}
      var scrollButton=event.target.closest('[data-edg-scroll-guide]');
      if(scrollButton){if(guide)guide.scrollIntoView({behavior:'smooth',block:'start'});return;}
      var fiHelpButton=event.target.closest('[data-edg-fi-help]');
      if(fiHelpButton&&root.contains(fiHelpButton)){
        patchSession(state);
        window.location.assign(fiHelpButton.getAttribute('data-edg-fi-help'));
        return;
      }
      if(event.target.closest('[data-edg-back]')){
        var previous=panelHistory.pop();
        if(previous){state=Object.assign({},previous.state);updateHarnessContext();patchSession(state);fixHomepageProductLinks(root,state);showPanel(previous.panel,true,true);}
        return;
      }
      var resetButton=event.target.closest('[data-edg-reset]');
      if(resetButton){
        state={fi:'',interest:'',fiModel:'',goal:'',wear:'',placement:'',need:'',closure:'',backsOut:'',color:''};
        if(colorInput)colorInput.value='';
        var feedbackForm=root.querySelector('[data-edg-harness-form]');
        var feedbackWrap=root.querySelector('[data-edg-harness-feedback-form-wrap]');
        var feedbackSuccess=root.querySelector('[data-edg-harness-success]');
        var feedbackStatus=root.querySelector('[data-edg-harness-status]');
        if(feedbackForm)feedbackForm.reset();
        if(feedbackWrap)feedbackWrap.hidden=false;
        if(feedbackSuccess)feedbackSuccess.hidden=true;
        if(feedbackStatus)feedbackStatus.textContent='';
        updateHarnessContext();
        patchSession(state);fixHomepageProductLinks(root,state);
        panelHistory=[];currentPanel='intro';showPanel('intro',true,true);
        return;
      }
      var resultCard=event.target.closest('[data-edg-result-card]');
      if(resultCard&&root.contains(resultCard)){
        var key=resultCard.getAttribute('data-edg-result-card');
        if(key.indexOf('fi-')===0&&['fi-traditional','fi-arctic','fi-martingale','fi-canvas'].indexOf(key)>=0)key=key.slice(3);
        if(key==='traditional') patchSession(state,'traditional');
        else if(key==='arctic') patchSession(state,'arctic');
        else if(key==='martingale') patchSession(state,'martingale');
        else if(key==='canvas') patchSession(state,'signatureCanvas');
        else if(key==='fi3-behavior') patchSession(state,'adapter','fi3-behavior');
        else if(key==='fi3-compact') patchSession(state,'adapter','fi3-compact');
        else if(key==='mini-compact') patchSession(state,'adapter','mini-compact');
        else patchSession(state);
        return;
      }
      var comparisonLink=event.target.closest('.edg-home__comparison-card a');
      if(comparisonLink&&root.contains(comparisonLink)){
        var card=comparisonLink.closest('.edg-home__comparison-card');
        var family=card&&card.dataset.edgCollarFamily;
        if(family)patchSession(state,family==='canvas'?'signatureCanvas':family);
        return;
      }
      var button=event.target.closest('[data-edg-next]');
      if(!button||!root.contains(button))return;
      var previousState=Object.assign({},state);
      var dependentAnswers={
        edgWear:['fi','interest','fiModel','goal','placement','need','closure','backsOut'],
        edgFi:['interest','fiModel','goal','placement','need','closure','backsOut'],
        edgInterest:['fiModel','goal','placement','need','closure','backsOut'],
        edgFiModel:['goal','placement','need','closure','backsOut'],
        edgGoal:['placement','need','closure','backsOut'],
        edgClosure:['need','backsOut']
      };
      var answerKeys={edgWear:'wear',edgFi:'fi',edgInterest:'interest',edgFiModel:'fiModel',edgGoal:'goal',edgClosure:'closure'};
      Object.keys(dependentAnswers).forEach(function(key){
        if(button.dataset[key]!==undefined&&button.dataset[key]!==state[answerKeys[key]])
          dependentAnswers[key].forEach(function(field){state[field]='';});
      });
      if(button.dataset.edgFi!==undefined)state.fi=button.dataset.edgFi;
      if(button.dataset.edgInterest!==undefined){state.interest=button.dataset.edgInterest;if(button.dataset.edgInterest==='no')state.fi='no';if(button.dataset.edgInterest==='yes'||button.dataset.edgInterest==='maybe')state.fi='considering';}
      if(button.dataset.edgFiModel!==undefined)state.fiModel=button.dataset.edgFiModel==='fi3'?'series3plus':button.dataset.edgFiModel;
      if(button.dataset.edgGoal!==undefined)state.goal=button.dataset.edgGoal;
      if(button.dataset.edgWear!==undefined)state.wear=button.dataset.edgWear;
      if(button.dataset.edgPlacement!==undefined)state.placement=button.dataset.edgPlacement;
      if(button.dataset.edgClosure!==undefined)state.closure=button.dataset.edgClosure;
      if(button.dataset.edgBacksOut!==undefined){state.backsOut=button.dataset.edgBacksOut;state.need=state.backsOut==='yes'?'escape':'compare';}
      if(button.dataset.edgNeed!==undefined)state.need=button.dataset.edgNeed;
      if(button.dataset.edgColor!==undefined)state.color=button.dataset.edgColor;
      updateHarnessContext();
      patchSession(state);
      var next=button.dataset.edgNext;
      if(next==='color')next='result';
      if(next==='adapter-wear'&&(state.wear==='collar'||state.wear==='harness'))next='result';
      if(next==='need'&&(state.goal==='adapter'||state.goal==='help'))next='result';
      if(next==='need'&&state.fi==='no'&&state.wear==='harness')next='result';
      fixHomepageProductLinks(root,state);
      showPanel(next,true,false,previousState);
    });

    var harnessForm=root.querySelector('[data-edg-harness-form]');
    if(harnessForm){
      harnessForm.addEventListener('submit',function(event){
        event.preventDefault();
        var status=root.querySelector('[data-edg-harness-status]');
        var submit=root.querySelector('[data-edg-harness-submit]');
        var feedbackWrap=root.querySelector('[data-edg-harness-feedback-form-wrap]');
        var feedbackSuccess=root.querySelector('[data-edg-harness-success]');
        var answers=[].slice.call(harnessForm.querySelectorAll('textarea'));
        var hasAnswer=answers.some(function(field){return field.value.trim().length>0;});

        if(!hasAnswer){
          if(status)status.textContent='Tell me at least one thing about the harness your dog uses—or the harness you wish existed.';
          if(answers[0])answers[0].focus();
          return;
        }
        if(!harnessForm.reportValidity()) return;

        if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true');}
        if(status)status.textContent='Sending your feedback…';

        fetch(harnessForm.action,{
          method:'POST',
          body:new FormData(harnessForm),
          headers:{'Accept':'text/html'}
        }).then(function(response){
          return response.text().then(function(html){return {response:response,html:html};});
        }).then(function(result){
          var confirmed=result.response.ok&&(
            result.response.url.indexOf('contact_posted=true')>=0||
            result.html.indexOf('contact_posted=true')>=0
          );
          if(!confirmed) throw new Error('Feedback submission was not confirmed.');
          if(feedbackWrap)feedbackWrap.hidden=true;
          if(feedbackSuccess)feedbackSuccess.hidden=false;
          if(status)status.textContent='';
          try{sessionStorage.setItem('edg-harness-feedback-submitted-v1','true');}catch(e){}
        }).catch(function(){
          if(status)status.textContent='I couldn’t confirm that the feedback was sent. Your answers are still here—try again, or skip for now and keep shopping.';
        }).then(function(){
          if(submit){submit.disabled=false;submit.removeAttribute('aria-busy');}
        });
      });
    }

    var colorSubmit=root.querySelector('[data-edg-color-submit]');
    if(colorSubmit)colorSubmit.addEventListener('click',function(){state.color=colorInput?colorInput.value.trim():'';patchSession(state);showPanel('result');});
    if(colorInput)colorInput.addEventListener('keydown',function(event){if(event.key==='Enter'){event.preventDefault();state.color=colorInput.value.trim();patchSession(state);showPanel('result');}});
    function applyFiReturnChoice(){
      var fiReturnModel='';
      try{fiReturnModel=new URLSearchParams(window.location.search).get('edg_fi_model')||'';}catch(e){}
      if(fiReturnModel==='none'){
        state.fi='no';
        state.interest='';
        state.fiModel='';
        state.goal='';
        var noFiStore=loadStore();
        var savedNoFi=noFiStore.dogs[noFiStore.activeIndex];
        if(savedNoFi&&savedNoFi.wear)state.wear=savedNoFi.wear;
        patchSession(state);
        showPanel('need',false);
        return true;
      }
      if(['fi2','series3','series3plus','mini','ultra'].indexOf(fiReturnModel)>=0){
        state.fi='yes';
        state.fiModel=fiReturnModel;
        var fiStore=loadStore();
        var savedFi=fiStore.dogs[fiStore.activeIndex];
        if(savedFi&&savedFi.wear)state.wear=savedFi.wear;
        updateHarnessContext();
        patchSession(state);
        showPanel('fi-choice',false);
        return true;
      }
      return false;
    }
    updateHarnessContext();
    if(!applyFiReturnChoice())showPanel('intro',false);
    fixHomepageProductLinks(root,state);
    window.addEventListener('pageshow',function(event){
      if(event.persisted)applyFiReturnChoice();
    });
  }

  window.EDGHomeGearFirst=window.EDGHomeGearFirst||{};
  window.EDGHomeGearFirst.init=init;
  if(!window.EDGHomeGearFirst.listenerBound){window.EDGHomeGearFirst.listenerBound=true;document.addEventListener('shopify:section:load',function(event){window.EDGHomeGearFirst.init(event.target);});}
  init(document);
})();




